<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <!-- TODO: Should have [required]="true", but because of required FormsModule directly, it creates issues on edit -->
  <ix-file-input
    formControlName="upload_credentials"
    [label]="'Service Account Key' | translate"
    [tooltip]="helptext.service_account_credentials_google_cloud_storage.tooltip | translate"
  ></ix-file-input>

  <ix-textarea
    formControlName="service_account_credentials"
    [label]="'Preview JSON Service Account Key' | translate"
    [readonly]="true"
    [tooltip]="helptext.preview_google_cloud_storage.tooltip | translate"
  ></ix-textarea>
</ix-fieldset>
